import { useSelector } from 'react-redux';

export const sessionSelector = () => useSelector((state) => state.session);

const selectors = {
  sessionSelector,
};

export default selectors;
